module.exports = __webpack_public_path__ + "img/pump2.6da12a37.jpg";